import { Controller } from "@hotwired/stimulus"

// Explorer month filters: keep hidden date params in sync and auto-submit.
export default class extends Controller {
  static targets = ["from", "to", "fromHidden", "toHidden", "rangeToggle", "rangeWrapper"]

  connect() {
    this.updateRangeMode()
    this.sync()
    // Some browsers restore checkbox state after connect; resync on next tick.
    setTimeout(() => {
      this.updateRangeMode()
      this.sync()
    }, 0)
  }

  toggleRange() {
    this.updateRangeMode()
    this.syncAndSubmit()
  }

  syncAndSubmit() {
    this.sync()
    if ((this.hasFromTarget && !this.fromTarget.checkValidity()) || (this.isRangeMode() && this.hasToTarget && !this.toTarget.checkValidity())) return
    if (this.isRangeMode() && this.hasFromTarget && this.hasToTarget && this.fromTarget.value && this.toTarget.value && this.fromTarget.value > this.toTarget.value) return
    this.element.requestSubmit()
  }

  sync() {
    if (this.hasFromHiddenTarget && this.hasFromTarget) this.fromHiddenTarget.value = this.monthStart(this.fromTarget.value)
    const toMonth = this.isRangeMode() && this.hasToTarget ? this.toTarget.value : (this.hasFromTarget ? this.fromTarget.value : "")
    if (this.hasToHiddenTarget) this.toHiddenTarget.value = this.monthEnd(toMonth)
  }

  isRangeMode() {
    return this.hasRangeToggleTarget && this.rangeToggleTarget.checked
  }

  updateRangeMode() {
    if (!this.hasRangeWrapperTarget) return
    const enabled = this.isRangeMode()
    this.rangeWrapperTarget.classList.toggle("hidden", !enabled)
    if (this.hasToTarget) this.toTarget.disabled = !enabled
  }

  monthStart(monthValue) {
    return monthValue ? `${monthValue}-01` : ""
  }

  monthEnd(monthValue) {
    if (!monthValue) return ""
    const [yearStr, monthStr] = monthValue.split("-")
    const year = Number(yearStr)
    const month = Number(monthStr)
    if (!year || !month) return ""
    const lastDay = new Date(year, month, 0).getDate()
    return `${yearStr}-${monthStr}-${String(lastDay).padStart(2, "0")}`
  }
}
